import { Navigate, useLocation, useParams } from "react-router-dom";

/** Old URL `/assets/:uuid` → canonical edit URL `/assets/:uuid/edit`. */
export default function AssetUuidRedirect() {
  const { uuid } = useParams<{ uuid: string }>();
  const location = useLocation();
  if (!uuid) return <Navigate to="/assets" replace />;
  return (
    <Navigate to={`/assets/${uuid}/edit`} replace state={location.state} />
  );
}
